import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { formatTime } from "../../../../../Helpers/missionHelper";
import config from "../../../../../config";
import { SUPPORT_EMAIL } from "../../Constants/missionConstants";

function MissionStatusScreen({
  status,
  missionName,
  timeLeftToStart,
  contextData,
  id,
}) {
  const getStatusContent = () => {
    switch (status) {
      case "missionNotStarted":
        return {
          title: `${
            contextData?.missions?.find((miss) => miss?.id == id)?.name
          } Not Started Yet`,
          subtitle: "Time left to start:",
          time: formatTime(timeLeftToStart),
          message: "Please wait until the mission begins.",
          footer: "Be Ready!",
        };

      case "missionEnded":
        return {
          title: `${missionName} Finished`,
          subtitle: "The mission is now over. Thank you for participating!",
          message: `If you have any questions, contact `,
          showEmail: true,
        };

      case "missionPaused":
        return {
          title: missionName ? `${missionName} is paused` : "Be Ready!",
          message: "Please wait until the mission begins again.",
          footer: "Be Ready!",
        };

      default:
        return {
          title: missionName
            ? `${missionName} can not be submitted now`
            : "Be Ready!",
          message: "Please wait until the mission starts.",
          footer: "Be Ready!",
        };
    }
  };

  const content = getStatusContent();

  return (
    <Box
      sx={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        px: 2,
      }}
    >
      <AccessTimeIcon
        sx={{ fontSize: 80, color: config.PRIMARY_COLOR, mb: 2 }}
      />
      <Typography
        variant="h3"
        sx={{ fontWeight: 900, color: config.PRIMARY_COLOR, mb: 2 }}
      >
        {content.title}
      </Typography>
      {content.subtitle && (
        <Typography variant="h5" sx={{ color: "#333", mb: 3 }}>
          {content.subtitle}
        </Typography>
      )}
      {content.time && (
        <Typography
          sx={{
            fontFamily: "monospace",
            fontSize: { xs: "56px", md: "72px" },
            color: "success.main",
            fontWeight: 900,
            letterSpacing: 2,
            lineHeight: 1,
            textShadow: "0 2px 12px #b3e6b3a0",
            mb: 1,
          }}
        >
          {content.time}
        </Typography>
      )}
      {content.message && (
        <Typography sx={{ color: "#666", fontSize: 16, fontWeight: 400 }}>
          {content.message}
          {content.showEmail && (
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              style={{
                color: config.PRIMARY_COLOR,
                textDecoration: "underline",
              }}
            >
              {SUPPORT_EMAIL}
            </a>
          )}
        </Typography>
      )}
      {content.footer && (
        <Typography sx={{ color: "#666", fontSize: 16, fontWeight: 400 }}>
          {content.footer}
        </Typography>
      )}
    </Box>
  );
}

export default MissionStatusScreen;
